import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Users } from 'lucide-react';
import { useSocialStore } from '../store/socialStore';
import ProjectCard from '../components/social/ProjectCard';
import { useContextualNavigation } from '../hooks/useContextualNavigation';

const PAGE_SIZE = 20;

const FollowingFeedPage: React.FC = () => {
  const { navigateWithContext } = useContextualNavigation();
  const {
    feedProjects,
    feedTotalCount,
    feedLoading,
    loadFollowingFeed,
  } = useSocialStore();

  const [skip, setSkip] = useState<number>(0);

  useEffect(() => {
    loadFollowingFeed(skip, PAGE_SIZE);
  }, [skip, loadFollowingFeed]);

  const handleProjectClick = (projectId: number) => {
    navigateWithContext(`/shared/projects/${projectId}`, 'Following Feed');
  };

  return (
    <div className="p-6 max-w-7xl mx-auto">
      {/* Header */}
      <div className="flex items-center gap-3 mb-6">
        <Users className="w-6 h-6 text-primary-600 dark:text-primary-400" aria-hidden="true" />
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
          Following Feed
        </h1>
      </div>

      {/* Loading State */}
      {feedLoading && (
        <div className="flex items-center justify-center py-12">
          <p className="text-gray-500 dark:text-gray-400">Loading...</p>
        </div>
      )}

      {/* Empty State */}
      {!feedLoading && feedProjects.length === 0 && (
        <div className="flex flex-col items-center justify-center py-12 text-center">
          <Users className="w-12 h-12 text-gray-300 dark:text-gray-600 mb-3" />
          <p className="text-gray-500 dark:text-gray-400 mb-4">
            No projects yet. Follow users to see their public projects here.
          </p>
          <Link
            to="/explore"
            className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-primary-600 rounded-md hover:bg-primary-700 transition-colors"
          >
            Explore Projects
          </Link>
        </div>
      )}

      {/* Project List */}
      {!feedLoading && feedProjects.length > 0 && (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {feedProjects.map((project) => (
            <ProjectCard
              key={project.project_id}
              project={project}
              onClick={handleProjectClick}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default FollowingFeedPage;
